import {BaseConverter} from '../../base/converters/base-converter.converter';
import {PropertyModel} from '../models/property.model';
import {Property} from '../../shared/DTO/property';
import {CpaConverter} from './cpa.converter';
import {EnrichmentConverter} from './enrichment.converter';
import {Injectable} from '@angular/core';

@Injectable()
export class PropertyConverter extends BaseConverter<PropertyModel, Property> {

  constructor(private cpaConverter: CpaConverter, private enrichmentConverter: EnrichmentConverter) {
    super();
  }

  convertToDto(model: PropertyModel): Property {
    return undefined;
  }

  convertToModel(dto: Property): PropertyModel {
    if (!dto) {
      return null;
    }

    let model: PropertyModel = new PropertyModel();
    model.admittedValues = dto.admittedValues;
    model.cpa = this.cpaConverter.convertToModelList(dto.cpa);
    model.description = dto.description;
    model.enrichment = this.enrichmentConverter.convertToModel(dto.enrichment);
    model.mandatory = dto.mandatory;
    model.name = dto.name;
    model.usable = dto.usable;
    model.valorization = dto.valorization;
    model.value = dto.value;

    return model;
  }

}
